/**
 * Hosting serves Laravel from the project root, so media lives under `/public/images/`.
 * The API may return URLs without that segment; fix them for `<img src>`.
 */
const BACKEND_HOSTS = new Set([
  'admin.qbcon.in',
  'localhost',
  '127.0.0.1',
])

function publicPrefix(): string {
  const raw = (import.meta.env.VITE_PUBLIC_URL_PREFIX ?? 'public').trim().replace(/^\/|\/$/g, '')
  return raw
}

export function normalizeMediaUrl(url: string | null | undefined): string {
  const value = (url ?? '').trim()
  if (!value) return ''

  if (value.startsWith('data:') || value.startsWith('blob:')) {
    return value
  }

  const prefix = publicPrefix()

  // Relative paths from API (`/images/...`)
  if (value.startsWith('/images/') && prefix) {
    return `/${prefix}${value}`
  }

  if (!/^https?:\/\//i.test(value)) {
    return value
  }

  try {
    const parsed = new URL(value)

    if (!BACKEND_HOSTS.has(parsed.hostname)) {
      return value
    }

    if (prefix && parsed.pathname.startsWith('/images/') && !parsed.pathname.startsWith(`/${prefix}/`)) {
      parsed.pathname = `/${prefix}${parsed.pathname}`
      return parsed.toString()
    }

    // Local Vite proxies `/images` to Laravel — use a same-origin path so the
    // uploaded city photo actually loads instead of falling back.
    if (!prefix && parsed.pathname.startsWith('/images/')) {
      return parsed.pathname
    }
  } catch {
    return value
  }

  return value
}
